import { isEmpty } from 'lodash';

export const checkSelectionValidity = (required, selections, ref) => {
  if (required) {
    if (
      !selections ||
      isEmpty(selections) ||
      !Object.values(selections)?.some((x) => x)
    ) {
      ref?.current?.setCustomValidity('At least one option should be checked.');
      return;
    }
    ref?.current?.setCustomValidity('');
  }
};
